import React, { useState } from 'react'
import { Grid, Row, Panel, Table } from 'rsuite'

export default function ProgessResultView(props) {
  const { Column, HeaderCell, Cell } = Table

  const { schema } = props

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Table
              rowKey="id"
              cellBordered
              // height={400}
              // autoHeight={schema.expectedResult?.values?.length <= 7}
              autoHeight
              wordWrap={true}
              data={schema.expectedResult?.values || []}
            >
              <Column width={500}>
                <HeaderCell>{schema.expectedResult.columnText1}</HeaderCell>
                <Cell dataKey="expectedValue" />
                {/* <Cell>
                  {(rowData) => {
                    return <div dangerouslySetInnerHTML={{ __html: rowData.expectedValue }} />
                  }}
                </Cell> */}
              </Column>

              <Column width={'auto'}>
                <HeaderCell>{schema.expectedResult.columnText2}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <div
                        // style={{ whiteSpace: 'pre-line' }} // ใส่เพื่อให้ render \n ได้
                        dangerouslySetInnerHTML={{
                          __html: rowData.actualValue,
                        }}
                      />
                    )
                  }}
                </Cell>
              </Column>
            </Table>

            <Table
              rowKey="id"
              cellBordered
              // height={400}
              // autoHeight={schema.expectedResult?.values?.length <= 7}
              autoHeight
              wordWrap={true}
              data={schema.extendResult?.values || []}
            >
              <Column width={500}>
                <HeaderCell>{schema.extendResult.columnText1}</HeaderCell>
                <Cell dataKey="expectedValue" />
              </Column>

              <Column width={'auto'}>
                <HeaderCell>{schema.extendResult.columnText2}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <div
                        // style={{ whiteSpace: 'pre-line' }} // ใส่เพื่อให้ render \n ได้
                        dangerouslySetInnerHTML={{
                          __html: rowData.actualValue,
                        }}
                      />
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
